import axios, { type AxiosResponse } from 'axios';

import { getAPIUrls } from '../../../util/env';
import type { PMSVendorData, PmsSourceKey } from '@/types/pms.types';
import type { PmsSyncLogWire } from '../services/pmsConnectionApi';
import type { PmsAccountRef } from '../services/pmsAccount';
import { pmsEntityPath } from '../services/pmsEntityPath';

// PMS configuration keeps raw axios (CLAUDE.md, accepted as-is); DV-3345 types it.

/** GET …/connect: the account's connection records, masked since DV-3414. */
export const getVendorsListAPI = (
  account: PmsAccountRef,
  pmsSource?: PmsSourceKey
): Promise<AxiosResponse<PMSVendorData[]>> => {
  const query = pmsSource ? `?pmsSource=${pmsSource}` : '';
  return axios.get<PMSVendorData[]>(getAPIUrls(`${pmsEntityPath(account)}/connect${query}`));
};

/** GET …/syncLogs. An account that never synced gets an empty 200 body, which axios hands over as ''. */
export const getSyncLogsAPI = (account: PmsAccountRef): Promise<AxiosResponse<PmsSyncLogWire | ''>> =>
  axios.get<PmsSyncLogWire | ''>(getAPIUrls(`${pmsEntityPath(account)}/syncLogs`));
